export default __webpack_public_path__ + "static/media/heading-bg.fcc6db47.png";